"use client";

import {
  Plus
} from "lucide-react";
import ServiceCard from "./ServiceCard";
import Reveal from "../motion/Reveal";
import Link from "next/link";
import Stagger, { StaggerItem } from "../motion/Stagger";
import { allServices } from "@/data/Static/services";
import SquareButton from "../Shared/Basic/SquareButton";

const topServices = allServices.slice(0, 6);

const ServicesSection = () => {
  return (
    <section className="py-6 md:py-20 bg-white" aria-labelledby="services-heading">
      <div className="container px-4 mx-auto">
        
        {/* Section Header - Compact */}
        <header className="relative mb-4 md:mb-10 ">
            <Reveal>
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                    <div className="space-y-4">
                       
                        <h2 id="services-heading" className="text-3xl md:text-5xl font-display font-bold text-foreground leading-tight tracking-tight">
                            Kiemelt <span className="text-primary ">Kezeléseink</span> 
                        </h2>
                    </div>
                    
                    <Link href="/szolgaltatasok" className="hidden md:block">
                        <SquareButton 
                          label="ÖSSZES MEGTEKINTÉSE" 
                          borderSize="sm"
                          className="min-w-64 h-12"
                          textColor="text-primary"
                          borderColor="border-primary/20"
                          borderHighlightColor="group-hover:border-primary"
                          bgHighlightColor="group-hover:bg-primary"
                          textHighlightColor="group-hover:text-white"
                        />
                    </Link>
                </div>
            </Reveal>
        </header>

        {/* Desktop Grid Container */}
        <div className="hidden md:block">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {topServices.map((service, index) => (
              <Reveal key={service.id} delay={index * 0.1}>
                <ServiceCard
                  title={service.title}
                  description={service.description}
                  icon={service.icon}
                  href={service.href}
                  color={service.color}
                  bgColor={service.bgColor}
                  hoverColor={service.hoverColor}
                  hoverBorder={service.hoverBorder}
                />
              </Reveal>
            ))}
          </div>
        </div>

        {/* Mobile Vertical List Container */}
        <div className="md:hidden space-y-2">
            <div className="max-h-[500px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-primary/20">
                <Stagger staggerDelay={0.05}>
                    {topServices.slice(0, 5).map((service) => (
                        <StaggerItem key={service.id}>
                            <ServiceCard
                                compact
                                title={service.title}
                                description={service.description}
                                icon={service.icon}
                                href={service.href}
                                color={service.color}
                                bgColor={service.bgColor}
                                hoverColor={service.hoverColor}
                                hoverBorder={service.hoverBorder}
                            />
                        </StaggerItem>
                    ))}
                </Stagger>
            </div>
            
            {/* Elegant Mobile Navigation */}
            <div className="mt-8 pt-4 border-t border-border flex justify-center">
                <Link 
                    href="/szolgaltatasok" 
                    className="group inline-flex items-center gap-2 text-primary text-xs font-black uppercase tracking-[0.3em] py-2 transition-all"
                >
                    Összes szolgáltatás megtekintése
                    <Plus className="w-3 h-3 group-hover:rotate-90 transition-transform duration-300" />
                </Link>
            </div>
        </div>

      </div>
    </section>
  );
};

export default ServicesSection;
